var reactiveEnergy = {
  VARh: {
    to_anchor: 1
  }, 
  mVARh: {
    to_anchor: .001
  }, 
  kVARh: {
    to_anchor: 1000
  }, 
  MVARh: {
    to_anchor: 1000000
  }, 
  GVARh: {
    to_anchor: 1000000000
  }
};

module.exports = {
  metric: reactiveEnergy, 
  _anchors: {
    metric: {
      unit: 'VARh', 
      ratio: 1
    }
  }
};
